<div class="container-fluid templates-page">

    <div class="templates-card">

        <!-- ================================================== -->
        <!-- HEADER -->
        <!-- ================================================== -->

        <div class="templates-header">

            <div class="header-content">

                <!-- TÍTULO -->

                <div class="header-info">

                    <h1 class="page-title">
                        Plantillas
                    </h1>

                    <p class="page-description">
                        Administra y configura las plantillas disponibles.
                    </p>

                </div>


                <!-- ACCIONES -->

                <div class="header-actions">

                    <button
                        type="button"
                        class="btn-create"
                        (click)="createPlantilla()">

                        <i class="fa-solid fa-plus"></i>

                        <span>
                            Crear plantilla
                        </span>

                    </button>

                </div>

            </div>

        </div>


        <!-- ================================================== -->
        <!-- BODY -->
        <!-- ================================================== -->

        <div class="templates-body">


            <!-- ================================================= -->
            <!-- TOOLBAR -->
            <!-- ================================================= -->

            <div class="content-toolbar">


                <!-- ============================================= -->
                <!-- BUSCADOR -->
                <!-- ============================================= -->

                <div class="search-container">

                    <form
                        [formGroup]="searchForm"
                        class="search-form">

                        <div class="search-box">


                            <!-- ICONO -->

                            <div class="search-icon">

                                <i class="fa-solid fa-magnifying-glass"></i>

                            </div>


                            <!-- INPUT -->

                            <input
                                type="text"
                                class="search-input"
                                placeholder="Buscar plantilla..."
                                formControlName="search"
                                (keyup.enter)="buscarPlantilla()" />


                            <!-- BOTÓN -->

                            <button
                                class="search-button"
                                type="button"
                                (click)="buscarPlantilla()">

                                Buscar

                            </button>

                        </div>

                    </form>

                </div>

            </div>


            <!-- ================================================= -->
            <!-- TABLA -->
            <!-- ================================================= -->

            <div class="table-section">

                <app-paginacion
                    [currentPage]="currentPage"
                    [totalItems]="totalItems"
                    [selectedPageSize]="pageSize"
                    [paginatedData]="currentItems"
                    [headers]="tableHeaders"
                    [actions]="customActions"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)"
                    [loading]="spinner">
                </app-paginacion>

            </div>

        </div>

    </div>

</div>